// extracted by mini-css-extract-plugin
export default {"rebrandingTooltip":"FaceInfoTooltip__rebrandingTooltip--UEleF"};